import {Component, store, setState} from 'Generic';
import {paymentNameTranslation} from 'Generic/constants/common';
import {CREDIT_CARD_ICON, paymentWallIconMap} from 'Generic/constants/paymentWallIcon';
import {getTranslation, updatePaymentMethodsFields, isApplePayPreferredBrowser} from 'Generic/lib';

export default class Gateways extends Component {
  constructor() {
    super({
      store,
      element: document.querySelector('#payment_gateways'),
      state: store.state,
    });
  }

  render() {
    let gatewayList = this.state.selected_plan.gateways;
    if (gatewayList) {
      gatewayList = gatewayList.slice();
      const applePayIndex = gatewayList.findIndex(gateway => gateway.logical_key === 'applepay');
      if (applePayIndex > 0 && isApplePayPreferredBrowser()) {
        const [applePayGateway] = gatewayList.splice(applePayIndex, 1);
        gatewayList.unshift(applePayGateway);
      }
    }
    const selectedGatewayKey = this.state.selected_gateway;
    let desktopGatewayHtml = '';

    if (gatewayList) {
      // Skip Stripe if disabled
      if (cartState.stripe_disabled) {
        gatewayList = gatewayList.filter(gateway => gateway.logical_key !== 'stripe');
        if (!selectedGatewayKey || selectedGatewayKey === 'stripe') {
          selectedGatewayKey = gatewayList?.[1]?.logical_key;
          setState({selected_gateway: gatewayList?.[1]?.logical_key, selected_gateway_name: gatewayList?.[1]?.name});
        }
      }

      let selectedGateway = gatewayList.find(gateway => gateway.logical_key == selectedGatewayKey);

      if (!selectedGateway) {
        selectedGateway = gatewayList[0];
        const key = selectedGateway.logical_key;
        const name = selectedGateway.name;
        setState({selected_gateway: key, selected_gateway_name: name});
      }

      desktopGatewayHtml += `<div class="gateway-boxes">
      <div id="myDropdown" class="dropdown-content">`;

      // const coinPaymentCond = gatewayList.some(gateway => gateway.logical_key === 'applepay') && gatewayList.length > 5;

      for (const gateway of gatewayList) {
        if (conditionalGateways[gateway.logical_key] === false) continue;
        // If apple pay is visible than coin payment is not visible
        // if (coinPaymentCond && conditionalGateways['applepay'] === true && gateway.logical_key === 'coinpayment') continue;

        const paymentWallIcon = paymentWallIconMap[gateway?.logical_key] || CREDIT_CARD_ICON;
        const paymentNameKey = paymentNameTranslation[gateway?.logical_key] || '';
        const paymentWallName = getTranslation(paymentNameKey) || gateway?.name;

        desktopGatewayHtml += `
          <div class="gateway-method payment_selection_box ${selectedGateway.logical_key == gateway.logical_key && 'active'}" id="${
          gateway.logical_key
        }_box_icon" data-name="${gateway.logical_key}" data-gateway-text="${gateway.name}">
            <div class="gateway-method-inr" data-gateway-type="recurring" data-eventcategory="Order Cart" data-eventaction="Payment gateway select" data-eventlabel="${
              gateway.logical_key
            }" data-eventvalue="1">
              ${paymentWallIcon}
              <span class="gateway-name">${paymentWallName}</span>
            </div>
          </div>
        `;
      }

      desktopGatewayHtml += `</div></div>`;

      updatePaymentMethodsFields(selectedGateway);
    }

    this.element.innerHTML = desktopGatewayHtml;
  }
}
